export const EdeisLargeTicketTemplate = `
<!DOCTYPE html>
<html>
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <style>
      @page{
        margin: 0;
        size: 101mm 54mm;
      }
      * {
        font-family: sans-serif;
        font-size: 10px;
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }

      .fsmall {
        font-size: 8px;
      }
      .freg {
        font-size: 10px;
      }
      .flarge {
        font-size: 16px;
      }
      .ftitle {
        font-size: 20px;
      }
      .f-bold {
        font-weight: bold;
      }
      .f-center {
        text-align: center;
      }
      .font-transparent {
        color: transparent;
      }

      .ticket {
        width: 101mm;
        height: 53mm;
        max-width: 101mm;
        max-height: 53mm;
        padding: 1mm 2mm;
        padding-right: 15mm;
        gap: 2mm;
      }

      .left,
      .center,
      .right {
        height: 100%;
        position: relative;
      }
      .left {
        max-width: 25mm;
      }
      .right {
        min-width: 10mm;
      }
      .qrcode {
        width: 25mm;
        height: 25mm;
      }
      .qrcode img {
        width: 100%;
        height: 100%;
      }
      .logo {
        height: 15mm;
      }

      .d-flex {
        display: flex;
      }
      .fl-col {
        flex-direction: column;
      }
      .fl-jsb {
        justify-content: space-between;
      }
      .fl-jc {
        justify-content: center;
      }
      .fl-je {
        justify-content: flex-end;
      }
      .fl-se {
        justify-content: space-evenly;
      }
      .fl-jsa {
        justify-content: space-around;
      }
      .fl-ac {
        align-items: center;
      }
      .fl-ae {
        align-items: flex-end;
      }
      .mb-10 {
        margin-bottom: 10px;
      }
      .mb-5 {
        margin-bottom: 5px;
      }
      .mt-5 {
        margin-top: 5px;
      }
      .pb-10 {
        padding-bottom: 10px;
      }
      .pt-10 {
        padding-top: 10px;
      }
      .pr-10 {
        padding-right: 10px;
      }
      .pl-10 {
        padding-left: 10px;
      }
    </style>
  </head>
  <body>
    <div class="ticket d-flex">
      <div class="left d-flex fl-col fl-jsb">
        <p class="fsmall">
          {{ groupInfo.address }}
        </p>
        <div>
          <p class="f-bold">{{fieldReference}}: {{bookingRef}}</p>
          <p class="f-bold">ID: {{barCode}}</p>
          <p></p>
        </div>
        <div class="qrcode">
          <img
            src="{{ qrCode }}"
          />
        </div>
      </div>

      <div class="center d-flex fl-col fl-jsb">
        <div class="d-flex fl-col">
          <p class="ftitle f-bold mb-5">{{ productName }}</p>
          <p class="freg f-bold mb-10">{{ startDateTime }}</p>

          <p>{{ seat }}</p>
        </div>

        <div>
          <!-- custom fields -->
        </div>

        <div class="info">
          <p class="freg mb-5"></p>
          <p class="freg f-bold mb-5">{{ name }}</p>
          <p class="freg mb-10">{{ currency }} {{ priceValue }} <span>({{ priceName }})</span></p>
          <p class="fsmall f-bold ">Billet non échangeable / non remboursable</p>
        </div>
      </div>

      <div class="right d-flex fl-je fl-ac">
        <!-- <div class="logo">LOGO</div> -->
      </div>
    </div>
  </body>
</html>
`;

export const EdeisSmallTicketTemplate = `
<!DOCTYPE html>
<html>
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <style>
      @page{
        margin: 0;
        size: 84mm 54mm;
      }
      * {
        font-family: sans-serif;
        font-size: 9px;
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }

      .fsmall {
        font-size: 7px;
      }
      .freg {
        font-size: 9px;
      }
      .flarge {
        font-size: 14px;
      }
      .ftitle {
        font-size: 16px;
      }
      .f-bold {
        font-weight: bold;
      }
      .f-center {
        text-align: center;
      }
      .font-transparent {
        color: transparent;
      }

      .ticket {
        width: 84mm;
        height: 53mm;
        max-width: 84mm;
        max-height: 53mm;
        padding: 1mm 2mm;
        padding-right: 10mm;
        gap: 1mm;
      }

      .left,
      .center,
      .right {
        height: 100%;
        position: relative;
      }
      .left {
        max-width: 22mm;
      }
      .right {
        min-width: 8mm;
      }
      .qrcode {
        width: 22mm;
        height: 22mm;
      }
      .qrcode img {
        width: 100%;
        height: 100%;
      }
      .logo {
        height: 12mm;
      }

      .d-flex {
        display: flex;
      }
      .fl-col {
        flex-direction: column;
      }
      .fl-jsb {
        justify-content: space-between;
      }
      .fl-jc {
        justify-content: center;
      }
      .fl-je {
        justify-content: flex-end;
      }
      .fl-se {
        justify-content: space-evenly;
      }
      .fl-jsa {
        justify-content: space-around;
      }
      .fl-ac {
        align-items: center;
      }
      .fl-ae {
        align-items: flex-end;
      }
      .mb-10 {
        margin-bottom: 8px;
      }
      .mb-5 {
        margin-bottom: 4px;
      }
      .mt-5 {
        margin-top: 4px;
      }
      .pb-10 {
        padding-bottom: 8px;
      }
      .pt-10 {
        padding-top: 8px;
      }
      .pr-10 {
        padding-right: 8px;
      }
      .pl-10 {
        padding-left: 8px;
      }
    </style>
  </head>
  <body>
    <div class="ticket d-flex">
      <div class="left d-flex fl-col fl-jsb">
        <p class="fsmall">
          {{ groupInfo.address }}
        </p>
        <div>
          <p class="f-bold">{{fieldReference}}: {{bookingRef}}</p>
          <p class="f-bold">ID: {{barCode}}</p>
          <p></p>
        </div>
        <div class="qrcode">
          <img
            src="{{ qrCode }}"
          />
        </div>
      </div>

      <div class="center d-flex fl-col fl-jsb">
        <div class="d-flex fl-col">
          <p class="ftitle f-bold mb-5">{{ productName }}</p>
          <p class="freg f-bold mb-5">{{ startDateTime }}</p>

          <p>{{ seat }}</p>
        </div>

        <div>
          <!-- custom fields -->
        </div>

        <div class="info">
          <p class="freg mb-5"></p>
          <p class="freg f-bold mb-5">{{ name }}</p>
          <p class="freg mb-5">{{ currency }} {{ priceValue }} <span>({{ priceName }})</span></p>
          <p class="fsmall f-bold ">Billet non échangeable / non remboursable</p>
        </div>
      </div>

      <div class="right d-flex fl-je fl-ac">
        <!-- <div class="logo">LOGO</div> -->
      </div>
    </div>
  </body>
</html>
`;

// For backward compatibility
export const EdeisTicketTemplate = EdeisLargeTicketTemplate;

export const PaulRicardTicketTemplate = `
<!DOCTYPE html>
<html>
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <style>
      @page{
        margin: 0;
        size: 101mm 54mm;
      }
      * {
        font-family: sans-serif;
        font-size: 10px;
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }

      .fsmall {
        font-size: 8px;
      }
      .freg {
        font-size: 10px;
      }
      .flarge {
        font-size: 16px;
      }
      .ftitle {
        font-size: 20px;
      }
      .f-bold {
        font-weight: bold;
      }
      .f-center {
        text-align: center;
      }
      .font-transparent {
        color: transparent;
      }

      .ticket {
        width: 101mm;
        height: 53mm;
        max-width: 101mm;
        max-height: 53mm;
        padding: 1mm 2mm;
        padding-right: 15mm;
        gap: 2mm;
      }

      .left,
      .center,
      .right {
        height: 100%;
        position: relative;
      }
      .left {
        max-width: 25mm;
      }
      .right {
        min-width: 10mm;
      }
      .qrcode {
        width: 25mm;
        height: 25mm;
      }
      .qrcode img {
        width: 100%;
        height: 100%;
      }
      .logo {
        height: 15mm;
      }

      .d-flex {
        display: flex;
      }
      .fl-col {
        flex-direction: column;
      }
      .fl-jsb {
        justify-content: space-between;
      }
      .fl-jc {
        justify-content: center;
      }
      .fl-je {
        justify-content: flex-end;
      }
      .fl-se {
        justify-content: space-evenly;
      }
      .fl-jsa {
        justify-content: space-around;
      }
      .fl-ac {
        align-items: center;
      }
      .fl-ae {
        align-items: flex-end;
      }
      .mb-10 {
        margin-bottom: 10px;
      }
      .mb-5 {
        margin-bottom: 5px;
      }
      .mt-5 {
        margin-top: 5px;
      }
      .pb-10 {
        padding-bottom: 10px;
      }
      .pt-10 {
        padding-top: 10px;
      }
      .pr-10 {
        padding-right: 10px;
      }
      .pl-10 {
        padding-left: 10px;
      }
    </style>
  </head>
  <body>
    <div class="ticket d-flex">
      <div class="left d-flex fl-col fl-jsb">
        <p class="fsmall">
          {{ groupInfo.address }}
        </p>
        <div>
          <p class="f-bold">{{fieldReference}}: {{bookingRef}}</p>
          <p class="f-bold">ID: {{barCode}}</p>
          <p></p>
        </div>
        <div class="qrcode">
          <img
            src="{{ qrCode }}"
          />
        </div>
      </div>

      <div class="center d-flex fl-col fl-jsb">
        <div class="d-flex fl-col">
          <p class="flarge f-bold mb-5">{{ productName }}</p>
          <p class="freg f-bold mb-10"></p>

          <p>{{ seat }}</p>
        </div>

        <div>
          <!-- custom fields -->
        </div>

        <div class="info">
          <p class="freg mb-5"></p>
          <p class="freg f-bold mb-5">{{ name }}</p>
          <p class="freg mb-10">{{ currency }} {{ priceValue }} <span>({{ priceName }})</span></p>
        </div>
      </div>
    </div>
  </body>
</html>
`;
